import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { INivelesPromo, T_TipoPromocion } from '../../../../private/shared/models/productos';

@Component({
  selector: 'getm-levels-stepper-bar',
  templateUrl: './levels-stepper-bar.component.html',
  styleUrls: ['./levels-stepper-bar.component.scss'],
})
export class LevelsStepperBarComponent implements OnInit {

  // TODO: Cambiara propiedades
  @Input() promoDetail = { title: '', available: 0, ends: '', select: 0, max: 0, tipoPromo: '' as T_TipoPromocion };
  @Input() niveles: INivelesPromo[] = [];
  @Input() level = 0;
  @Input() isEditing = false;
  @Input() isEditingLocked = false;

  @Output() levelClick = new EventEmitter<number>();
  @Output() backClick = new EventEmitter<void>();
  @Output() infoClick = new EventEmitter<void>();

  constructor() { }

  ngOnInit() { }

  public onLevelClick = (nivel: number) => this.levelClick.emit(nivel);

  public onBack = () => this.backClick.emit();

  public onInfoClick = () => this.infoClick.emit();

}
